import React, { useEffect, useState } from 'react';
import { AppConfig, AppConfigService, AppService, PathUtil } from '@aperza/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import style from './HeaderSearch.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
export function HeaderSearch({ suggestKeyword, onSuggestChange }) {
    const appConfig = AppService.appConfig();
    const { serviceType } = useAperzaUserContext();
    const getKeyword = () => AppConfigService.getSearchKeyword() ? AppConfigService.getSearchKeyword() : '';
    const [keyword, setKeyword] = useState(onSuggestChange ? suggestKeyword : getKeyword());
    let searchPlaceholder = 'アペルザに登録された8600社を超える企業の製品、カタログ、動画を検索';
    switch (serviceType) {
        case AppConfig.APERZA_CATALOG:
            searchPlaceholder = '8600社から5万点以上のカタログを検索';
            break;
        case AppConfig.APERZA_EC:
            searchPlaceholder = 'アペルザECで販売されている120万点以上の製品を検索できます';
            break;
        case AppConfig.APERZA_NEWS:
            searchPlaceholder = '製造業のニュースから検索';
            break;
        case AppConfig.APERZA_TV:
            searchPlaceholder = 'アペルザTVで配信されている700本以上の動画から検索';
            break;
        default:
            break;
    }
    const onSelect = async (val) => {
        if (val && val.length > 0) {
            const pathname = AppConfigService.getPath();
            const origin = AppConfigService.getOrigin();
            const { langCode } = appConfig;
            const encodedVal = encodeURIComponent(val);
            let url = '#';
            switch (serviceType) {
                case AppConfig.APERZA_CATALOG:
                    url = `${appConfig.searchWebUrlPrefix}/${langCode}/s/catalog/?k=${encodedVal}&rf=1110&ss=1`;
                    break;
                case AppConfig.APERZA_EC:
                    url = `${appConfig.marketplaceWebUrlPrefix}/s/item/?k=${encodedVal}&rf=1112&ss=1`;
                    break;
                case AppConfig.APERZA_NEWS:
                    url = `${origin}/?s=${encodedVal}`;
                    break;
                case AppConfig.APERZA_TV:
                    url = `${appConfig.aperzaTvHost}/search/?k=${encodedVal}`;
                    break;
                default: {
                    if (PathUtil.isSearchCatalogPage(pathname, langCode)) {
                        url = `${appConfig.searchWebUrlPrefix}/s/catalog/?k=${encodedVal}&rf=1110&ss=1`;
                    }
                    else if (pathname.startsWith(`/${langCode}/s/news/`)) {
                        url = `${appConfig.searchWebUrlPrefix}/s/news/?k=${encodedVal}&rf=1113&ss=1`;
                    }
                    else {
                        url = `${appConfig.searchWebUrlPrefix}/s/model/?k=${encodedVal}&rf=1109&ss=1`;
                    }
                    break;
                }
            }
            window.location.href = url;
        }
    };
    const onClickSuggestButton = async () => {
        const val = keyword;
        await onSelect(val.trim());
    };
    useEffect(() => {
        setKeyword(suggestKeyword);
    }, [suggestKeyword]);
    const onChange = async (e) => {
        const updatedKeyword = e?.target?.value;
        setKeyword(updatedKeyword || '');
        if (onSuggestChange) {
            onSuggestChange(updatedKeyword);
        }
    };
    const onInputKeyPress = (e) => {
        if (e.code === 'Enter') {
            onClickSuggestButton();
        }
    };
    return (React.createElement("div", { className: style.searchBox },
        React.createElement("input", { type: "search", className: style.searchInput, placeholder: searchPlaceholder, "aria-label": "Search", value: keyword, onChange: onChange, onKeyPress: onInputKeyPress }),
        React.createElement("button", { onClick: onClickSuggestButton, className: style.searchButton, type: "button" },
            React.createElement(FontAwesomeIcon, { icon: faSearch }))));
}
